<ng-container *ngIf="loading$ | async">
    <div class="loader">
        <div class="load"></div>
    </div>
    <div class="background-loader"></div>
</ng-container>
